import React from 'react'
import { Logger, noopLogger } from '@west-australian-newspapers/typescript-log'

export const LoggerContext = React.createContext<Logger>(noopLogger())
